import styles from './ColorPalettePicker.module.css';
import { ReactNode, useEffect, useState } from 'react';
import cn from 'classnames';
import { DirectionX, DirectionY } from '../../../../../utils/getAbsolutePosition';
import { AbsoluteContentButton } from '../../../../buttons/AbsoluteContentButton/AbsoluteContentButton';
import { Button, ButtonTone } from '../../../../buttons/Button/Button';
import { Icon } from '../../../../graphics/Icon/Icon';

type ColorPalettePickerProps = {
    colorPalette: string[];
    value?: string;
    onChange?: (color: string | null) => void;
    children?: ReactNode;
    className?: string;
};

export function ColorPalettePicker({
    colorPalette,
    value,
    onChange,
    children,
    className
}: ColorPalettePickerProps) {
    const [selectedColor, setSelectedColor] = useState<string | null>(value || null);

    useEffect(() => {
        setSelectedColor(value || null);
    }, [value]);

    useEffect(() => {
        if (selectedColor === null || colorPalette.includes(selectedColor))
            onChange?.(selectedColor);
    }, [selectedColor]);

    return (
        <AbsoluteContentButton
            tagName={Button}
            tone={ButtonTone.Hoverable}
            type={'button'}
            triggersOnHover={false}
            triggersOnClick={true}
            closeOnContentClick={true}
            closeOnTriggerClick={true}
            closeOnClickOutside={true}
            className={className}
            contentClassName={styles.colorPalette}
            content={
                <>
                    <button
                        type={'button'}
                        className={styles.noColor}
                        onClick={() => setSelectedColor(null)}
                    >
                        <Icon icon={'plus'} />
                    </button>
                    {colorPalette.map((color, index) => (
                        <button
                            key={color + '-' + index}
                            type={'button'}
                            className={styles.color}
                            style={{ backgroundColor: color }}
                            onClick={() => setSelectedColor(color)}
                        />
                    ))}
                </>
            }
            direction={[DirectionX.Center, DirectionY.Bottom]}
        >
            <span
                className={cn(styles.color, 'selected-color')}
                style={{ backgroundColor: selectedColor || 'transparent' }}
            />
            {children}
        </AbsoluteContentButton>
    );
}
